import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeSavedQuestionFilterVal, getSavedQuestions, getSavedQuizs } from 'examsbook-react-sdk/actions';
import { getFilteredQuestions } from 'examsbook-react-sdk/selectors';
import status from "examsbook-react-sdk/constants/actionStatus";
import { useTranslations } from "examsbook-react-sdk/custom-hooks";
import AppBar from '@material-ui/core/AppBar';
import AssignmentIcon from '@material-ui/icons/Assignment';
import CTabs from "../components/Tabs/CTabs";
import FavoriteItemsContainer from '../components/Tabs/FavoriteItemsContainer';
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

/**
 * SavedQuestionList
 * @returns {*}
 * @constructor
 */
function SavedQuestionList() {
    const t = useTranslations();
    const navigate = useNavigate();
    const questionList = useSelector((state) => getFilteredQuestions(state));
    const savedQuizList = useSelector((state) => state.savedQuizList.quizList);
    const questionsStatus = useSelector((state) => state.questionList.status);
    const questionLength = useSelector((state) => state.questionList.questions.length);
    const totalQuestions = questionList && questionList.length;
    let questionsLoading = (questionList && questionsStatus === status.PENDING);
    const [ selectedTab, setSelectedTab ] = useState(0);
    const dispatch = useDispatch();
    const user = useSelector((state) => state.user);

    useEffect(() => {
        dispatch(getSavedQuestions());
        dispatch(getSavedQuizs());
    }, [ dispatch, user ]);

    function filterQuestions(questionStatus) {
        dispatch(changeSavedQuestionFilterVal(questionStatus));
    }

    function handleTabChange(event, value) {
        setSelectedTab(value);
    }

    let tabBarList = [ {
        label: t('saved_quizzes'),
        ref: 'savedQuiz',
        icon: <AssignmentIcon/>
    }, {
        label: t('saved_questions'),
        ref: 'savedQuestions',
        icon: <i className="fa fa-bars  m-r-18" aria-hidden="true"/>
    } ];
    const isNativeApp = window.isNativeApp;

    function goToDashboard() {
        navigate('/my-app');
    }

    return (
        <div className="mock-test-section">
            <div className="top-header">
                <div className={isNativeApp ? "web-back-to-test" : "mobile-back-to-test"}>
                    <ArrowBackIcon onClick={goToDashboard}/>
                    <span>{selectedTab === 0 ? t('saved_quizzes') : t('saved_questions')}</span>
                </div>
                <div className={'mock-tabs'}>
                    <AppBar position="static" className="tabs">
                        <CTabs nav={tabBarList} setActiveTab={selectedTab} handleTabChange={handleTabChange}/>
                    </AppBar>
                    <FavoriteItemsContainer selectedIndex={selectedTab} savedQuizList={savedQuizList}
                                            questionLength={questionLength}
                                            filterQuestions={filterQuestions} totalQuestions={totalQuestions}
                                            questionList={questionList} questionsLoading={questionsLoading}
                                            navigate={navigate}/>
                </div>
            </div>
        </div>
    );
}

export default SavedQuestionList;
